import { useLocale } from "@genius-tracker/i18n/react";

import type { GtccViewDef } from "./registry.js";

export interface GtccStubViewProps {
  readonly view: GtccViewDef;
}

/**
 * A-GTCC-ST4 — der gemeinsame Stub-Hinweis. Ein optionaler Registry-Hinweis
 * kann den allgemeinen Platzhaltersatz und ein gtcc1-Pendant praezisieren.
 * Ohne Hinweis bleibt der generische Satz. Es bleibt ein Stub: keine Daten,
 * keine Anfrage, keine Aktion und kein Link auf eine spaeter entfernte Seite.
 */
export function GtccStubView({ view }: GtccStubViewProps) {
  const { t } = useLocale();
  const hint = view.stub;
  return (
    <div
      data-testid={`gtcc-view-${view.key}`}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gt-sys-space-3, 12px)",
        padding: "var(--gt-sys-space-5, 24px)",
      }}
    >
      <h2 style={{ margin: 0, fontSize: "var(--gt-sys-font-size-lg, 20px)" }}>{t(view.label)}</h2>
      <p
        style={{ margin: 0, color: "var(--gt-sys-text-muted, #6b7280)" }}
        data-testid={`gtcc-view-${view.key}-missing`}
      >
        {hint ? t(hint.missing) : t("admin.gtcc.stub_body")}
      </p>
      {hint ? (
        <p
          style={{
            margin: 0,
            color: "var(--gt-sys-text-muted, #6b7280)",
            fontSize: "var(--gt-sys-font-size-xs, 12px)",
            borderBlockStart: "1px solid var(--gt-sys-border)",
            paddingBlockStart: "var(--gt-sys-space-2, 8px)",
          }}
          data-testid={`gtcc-view-${view.key}-pendant`}
        >
          {t(hint.pendant)}
        </p>
      ) : null}
    </div>
  );
}
